goog.provide("shadow.js.shim.module$$embedpdf$engine");
goog.provide("module$shadow_js_shim_module$$embedpdf$engine");
shadow.js.shim.module$$embedpdf$engine = shadow.js.nativeProvides["@embedpdf/engine"] = shadow$bridge("@embedpdf/engine");
module$shadow_js_shim_module$$embedpdf$engine.default = shadow.js.shim.module$$embedpdf$engine;
